import moment from "moment";
import { Subscription } from "./subscription";

/* eslint-disable no-unused-expressions */
class AscmuSubscription extends Subscription {
  constructor(organizationId = null, subscriptionId = null) {
    super(organizationId, subscriptionId);
    // リクエスト時にのみ利用している
    this._monitoringDeviceId;
  }

  get monitoringDeviceId() {
    return this._monitoringDeviceId;
  }

  set monitoringDeviceId(value) {
    this._monitoringDeviceId = value;
  }

  json() {
    return {
      ...super.json(),
      metadata: {
        monitoringDeviceId: this.monitoringDeviceId,
      },
    };
  }

  copy() {
    const subscription = new AscmuSubscription(this.organizationId, this.subscriptionId);
    subscription.copyProperties(this);
    return subscription;
  }

  copyProperties(subscription) {
    super.copyProperties(subscription);
    this.monitoringDeviceId = subscription.monitoringDeviceId;
  }

  getApiRequestJson() {
    const requestJosn = super.getApiRequestJson();

    Object.assign(requestJosn, {
      metadata: {
        monitoring_device_id: this.monitoringDeviceId,
      },
    });
    return requestJosn;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    if (item.metadata) {
      this.monitoringDeviceId = item.metadata.monitoring_device_id;
    } else {
      this.monitoringDeviceId = null; // データが存在しない場合も、データ送信は行う。
    }
  }

  static getExpiresDateStr(format) {
    return moment().add(1, "y").format(format);
  }
}
/* eslint-enable */

export {
  AscmuSubscription,
};
